__webpack_require__.p = "https://beta.aesconsole.adect.amazon.dev/";